import "./App.css";
import logo from "./assets/baby.webp";

type LPConfig = {
  header: string;
  title: string;
  title2: string;
  subtitle: string;
  ctaButton: string;
  ctaSubtitle: string;
  footer: string;
};

const CONFIG: Record<string, LPConfig> = {
  "ph-geral": {
    header: "🎯 MELHORES PROMOÇÕES E CUPONS DO MUNDO BABY",
    title: "🚨 GRUPO VIP 🚨",
    title2: "100% GRATUITO",
    subtitle: "FRALDAS com 50% 60% 70% OFF 🥰",
    ctaButton: "QUERO PARTICIPAR",
    ctaSubtitle: "✨ JÁ SOMOS +120 MIL MAMÃES ✨",
    footer: "Direitos Reservados",
  },
};

function App() {
  const config = CONFIG["ph-geral"];

  return (
    <div className="container">
      <header className="header">
        <h1>{config.header}</h1>
      </header>

      <main className="main-content">
        <div className="vip-group-title">
          <p>{config.title}</p>
          <p>{config.title2}</p>
        </div>

        <div className="discount-text">{config.subtitle}</div>

        <div className="cta-container">
          <div className="icon-container">
            <img src={logo} alt="Shopping Bag" className="shopping-bag-icon" />
          </div>

          <a
            // href="https://chat.whatsapp.com/FSJtdIWqcXr7PULMkLKCSP"
            href="http://linktr.it/pbaby"
            className="cta-button animated-fast animated tada"
          >
            {config.ctaButton}
          </a>

          <div className="members-count">{config.ctaSubtitle}</div>
        </div>
      </main>

      <footer className="footer">{config.footer}</footer>
    </div>
  );
}

export default App;
